import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import SessionStore from 'stores/SessionStore';
import Multiselect from 'components/v2/multi-select';
import CustomerSearch from 'components/site/customer-search';
import DateRangeFilter from 'components/time/DateRangeFilter';
import CalendarIcon from 'components/v2/icons/CalendarIcon';
import { findThirdPartyCarriers } from 'utils/UserWebAPIUtils';
import { getDefaultDateRangeFilter } from 'helpers/date-range';
import AppointmentSearchFilter from './AppointmentSearchFilter';
import CustomerSearchV2 from '../../site/CustomerSearchFilter';
// @TODO
// - Implement bulk container filter
// - Implement
const DEFAULT_DATE_RANGE_VALUES = {
    startValue: 3,
    startTimeUnit: 'days',
    endValue: 10,
    endTimeUnit: 'days',
};
export default function AppointmentFilters({ onFilterChanged, appointmentStatuses, appointmentFacilities, }) {
    const { t } = useTranslation();
    const isAdmin = SessionStore.isAdmin();
    function onAppointmentSelect(key, appointment) {
        onFilterChanged(key, appointment);
    }
    const defaultDateRangeFilter = getDefaultDateRangeFilter(Object.assign({ options: 'object' }, DEFAULT_DATE_RANGE_VALUES));
    const onDateRangeChange = ({ filterType, start, end }) => {
        if (filterType === 'clear') {
            onFilterChanged('window_start', {
                window_start: undefined,
                window_end: undefined,
            });
        }
        else {
            onFilterChanged('daterange', { start, end });
        }
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex flex-col lg:flex-row lg:-mx-2" },
            React.createElement("div", { className: "w-full sm:w-auto sm:py-1 sm:mb-0 mb-2 lg:px-2" },
                React.createElement(DateRangeFilter, { showActionDropDown: true, buttonClassName: "flex w-full lg:w-48 button bg-white border shadow justify-center", onChange: onDateRangeChange, key: "daterange", initialStart: defaultDateRangeFilter.start, initialEnd: defaultDateRangeFilter.end, label: React.createElement("div", { className: "flex space-x-1" },
                        React.createElement("span", { className: "text-green" },
                            React.createElement(CalendarIcon, null)),
                        React.createElement("span", { className: "font-normal text-sm text-grey-darker" }, t('DATE_RANGE'))) })),
            React.createElement("div", { className: "w-full sm:w-auto sm:py-1 mb-2 sm:mb-0 lg:px-2" },
                React.createElement(Multiselect, { label: t('LOCATION'), searchKey: "name", valueKey: "name", items: appointmentFacilities, onSelect: (facility) => onFilterChanged('yard', facility), showSearchInput: false, showSelectedCount: false })),
            React.createElement("div", { className: "w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0" },
                React.createElement(Multiselect, { label: t('STATUS'), items: appointmentStatuses, onSelect: (status) => onFilterChanged('status', status), showSearchInput: false, showSelectedCount: false })),
            isAdmin && (React.createElement("div", { className: "w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0" },
                React.createElement(CustomerSearch, { id: "customer-search-input-consignee", clearOnSelect: true, onSelect: (_item, value) => onFilterChanged('consignee', value), placeholder: t('SEARCH_FOR_TYPE', {
                        type: 'Consignee',
                    }), type: "consignees", authorizedOnly: false }))),
            isAdmin && (React.createElement("div", { className: "w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0" },
                React.createElement(CustomerSearch, { id: "customer-search-input-shipper", clearOnSelect: true, onSelect: (_item, value) => onFilterChanged('shipper', value), placeholder: t('SEARCH_FOR_TYPE', {
                        type: 'Shipper',
                    }), type: "shippers", authorizedOnly: false }))),
            React.createElement("div", { className: "w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0" },
                React.createElement(CustomerSearchV2, { id: "customer-search-input-carrier", clearOnSelect: true, onSelect: (_item, value) => onFilterChanged('carrier', value), placeholder: t('SEARCH_FOR_TYPE', {
                        type: 'Carrier',
                    }), searchField: "name", type: "carriers", searchCustomers: findThirdPartyCarriers, authorizedOnly: false, userTag: t('THIRD_PARTY_CARRIER') })),
            React.createElement("div", { className: "w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0" },
                React.createElement(AppointmentSearchFilter, { placeholder: t('SEARCH_CONTAINER'), searchField: "container_number", onSelect: (value, row) => onAppointmentSelect('container_number', row) })),
            React.createElement("div", { className: "w-full sm:w-auto lg:px-2 sm:py-1 mb-2 sm:mb-0" },
                React.createElement(AppointmentSearchFilter, { placeholder: t('SEARCH_MASTER_BILL'), searchField: "master_bill_number", onSelect: (value, row) => onAppointmentSelect('master_bill_number', row) })))));
}
